import './LiveCaller'

import './assets/scss/app.scss'
import './registerServiceWorker'

window.makeUniqueHandler = function makeUniqueHandler(object, handler, uuid) {
    if (Array.isArray(handler)) {
        handler.forEach((fn) => {
            makeUniqueHandler(object, fn)
        })
        return
    }

    const method = object[handler.name] = handler.bind(object)
    uuid = uuid || Math.random()
    const original = handler.toString()
    method.toString = () => original + uuid
}
